import getClientPath from './getClientPath';
const setHtmlMeta = (title: string, icon: string, gameName: string) => {
    let titleTag: HTMLTitleElement | null =
        document.getElementsByTagName('title')[0];
    if (!titleTag) {
        titleTag = document.createElement('title');
        document.getElementsByTagName('head')[0].appendChild(titleTag);
    }
    titleTag.innerText = title;

    let link: HTMLLinkElement | null =
        document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    if (/\.[a-z]{3}$/.test(icon)) {
        link.href = `${getClientPath()}/static/favicons/${icon}`;
    } else {
        link.href = `${getClientPath()}/static/favicons/${icon}.svg`;
    }

    let canonical: HTMLLinkElement | null = document.querySelector(
        "link[rel~='canonical']",
    );
    if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.getElementsByTagName('head')[0].appendChild(canonical);
    }
    canonical.href = `https://turbogames.io/game/${gameName}`;

    let app: HTMLLinkElement | null = document.querySelector('#app');
    if (app) {
        document.body.classList.add(gameName);
        app.classList.add(gameName);
    }
};

export default setHtmlMeta;
